<template>
    <div class="container">
    <form class="row g-md-3 g-1 px-3 needs-validation" id="lotteryForm" @submit.prevent="submitForm" novalidate>
      <div class="col-md-6">
        <input type="text" class="form-control" id="validationCustom01" placeholder="First Name" v-model="form.firstName" required>
        <div class="invalid-feedback text-white validation-fz">
            Please provide your First Name
          </div>
        <div class="valid-feedback validation-fz ">
          Looks good!
        </div>
      </div>
      <div class="col-md-6">
        <input type="text" class="form-control" id="validationCustom01" placeholder="Last Name" v-model="form.lastName" required>
        <div class="invalid-feedback text-white validation-fz">
            Please provide your Last Name
          </div>
        <div class="valid-feedback validation-fz ">
          Looks good!
        </div>
      </div>
      <div class="col-md-6">
        <input type="phone" class="form-control" id="validationCustom01" placeholder="Phone Number" v-model="form.phone"  maxlength="10" minlength="10" pattern="^\d{10}$" required>
        <div class="invalid-feedback text-white validation-fz">
            Please provide a Valid Phone Number
          </div>
        <div class="valid-feedback validation-fz ">
          Looks good!
        </div>
      </div>
      <div class="col-md-6">
        <input type="text" class="form-control" id="validationCustom01" :placeholder="prizeCode" disabled v-model="form.prizeCode" required>
      </div>
      <div class="col-md-12">
        <input type="email" class="form-control" id="validationCustom01" placeholder="Email" v-model="form.email" required>
        <div class="invalid-feedback text-white validation-fz">
            Please provide a Valid Email
          </div>
        <div class="valid-feedback validation-fz ">
          Looks good!
        </div>
      </div>
      <div class="col-12 pt-md-3 pb-md-5 pt-4">
        <div class=" btn btn-shadow p-0 m-0 "><button class=" btn px-4 py-0 btn-spin mb-0 rounded-pill" type="submit">REGISTER NOW</button></div>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios';
import Confetti from 'canvas-confetti'

export default {
  props: [
    "prizeCode",
    "prizeName"
  ],
  data() {
    return {
      form: {
        webhookID: "c29e2002-d359-2b3d-35c4-b07f2d3740c8",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        notes: "",
        campaignName: "black-friday-2024",
        prize: '',
      },
    
    }
  },
  methods: {
    async submitForm({ target }) {
      if (target.checkValidity()) {
        this.form.notes = "Prize: " + this.prizeName + " | Prize Code: " + this.prizeCode
        this.form.prize = this.prizeName
            this.loadingMessage();
            var self = this;
            await axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
          .post('https://hooks.zapier.com/hooks/catch/11321198/2tjckb8/',this.form)
                .then(function (response) {
                    self.alertMessage() 
                    self.resetValues()
                })
                .catch(function (error) {
                    console.log(error);
                    self.errorMessage()
                });

      } else target.classList.add('was-validated')
    },
    submitFormt() {

        },
    errorMessage() {
      return Swal.fire({
        icon: "warning",
        title: "Oops",
        text: "An unexpected error ocurred, please try again.",
        iconColor: "#029195",
        showConfirmButton: false,
        timer: 5000,
        iconColor: "red",
        backdrop: `rgba(74, 192, 192,0.7)`,
      });
    },
    loadingMessage() {
      this.loading = Swal.mixin({
        customClass: {
          loader: 'spinner',
        }
      })
      return this.loading.fire({
        text: "Submitting",
        showConfirmButton: false,
        iconColor: "#39720b",
        color: "#39720b",
        backdrop: `rgba(74, 192, 192,0.7)`,
        width: 160,
        timerProgressBar: true,
        // timer: 3000,
        didOpen: () => {
          this.loading.showLoading();
        },
      });
    },
    alertMessage() {
      this.tab = 3
      localStorage.setItem('prize', 'true' );
      return Swal.fire({
        icon: "success",
        title: "Thanks, all ready set.",
        text: "An agent will be in touch with you soon.",
        color: "#029195",
        showConfirmButton: false,
        timer: 5000,
        iconColor: "#029195",
        backdrop: `rgba(74, 192, 192,0.7)`,
      });
    },
    initialValues() {
      return {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        prizeCode: null
      };
    },
    resetValues() {
      this.form = this.initialValues();
      document.getElementById("lotteryForm").classList.remove("was-validated");
    },
  },
  mounted() {

  }
}
</script>

<style scoped>
.btn-spin {
  background-color: #fff !important;
  font-family: Bebas Neue;
  color: #007591;
 border: none;
  font-size: 30px;
  box-shadow: 5px 4px 3px 1px rgba(155, 212, 22, 0.85);
  -webkit-box-shadow :0px 4px 0px 2px rgba(155, 212, 22, 1);
  -moz-box-shadow: 5px 4px 3px 1px rgba(155, 212, 22, 0.85);
  position: relative;
  z-index: 3 !important;
}

.btn-spin:hover {
  background-color: #fff !important;
  font-family: Bebas Neue;
  color: #007591;
 border: none;
  font-size: 30px;
  box-shadow: 5px 4px 3px 1px rgba(155, 212, 22, 0.85);
  -webkit-box-shadow :0px 4px 0px 2px rgba(155, 212, 22, 1);
  -moz-box-shadow: 5px 4px 3px 1px rgba(155, 212, 22, 0.85);
border-radius: 15px;
}

.swal2-loader {
  border-color: #ef527d!important;
}

.validation-fz {
  font-size: 11px;
  color: white!important;
}
</style>